<template>
  <div v-if="payment_way">
    <van-cell
      :title="payment_way === 'normal' ? '缴纳月份' : '补缴月份'"
      class="sby-period"
      :is-link="!readonly"
      @click.prevent="popupshow = !readonly"
    >
      <template v-slot:extra>
        <van-popup
          v-model="popupshow"
          position="bottom"
          get-container=".page-wrap"
          class="sby-period-container"
        >
        <sby-discount-tips v-if="enable_discount"></sby-discount-tips>

          <div class="period-row" v-if="payment_way === 'normal' && allow_select_payment">
            <span class="title">{{payment_way_desc}}服务项目 </span>
            <span v-if="isNormalPaymentWay()" class="desc">缴纳项目越多越优惠 </span>
          </div>
          <sby-block-container
            v-if="payment_way === 'normal' && allow_select_payment "
            v-model="new_payment_items"
            :item_list="getPaymentItemList()"
            :is_radio="payment_way === 'payback'"
            :item_refs="payment_item_refs"
            :min="1"
            @change="emitClick"
            :enable_discount="enable_discount"
            name="payment_items"
          ></sby-block-container>
          <div class="period-row">
            <span class="title">请选择{{payment_way_desc}}服务月份</span>
            <span v-if="isNormalPaymentWay() && allow_select_payment_term" class="desc">周期越长服务费越优惠</span>
          </div>
          <div class="period-row" v-if="isNormalPaymentWay() && allow_select_payment_term">
            <span
              v-for="(item, idx) in list"
              v-bind:key="idx"
              class="item"
              v-on:click="changePaymentTerm(item.value)"
              v-bind:class="{ active: isActivedItem(item.value) }"
            >
              <span>{{item.name}}</span>
              <div class="fees" v-if="service_fee_amts.origin">
                <span :class="enable_discount && service_fee_amts.discounts[item.value] > 0 ? 'origin-fee': ''">{{service_fee_amts.origin[item.value]}}元</span>
                <span v-if="enable_discount && service_fee_amts.discounts[item.value] > 0">
                  {{service_fee_amts.wait_fee[item.value]}} 元
                </span>
                <van-tag v-if="enable_discount && service_fee_amts.discounts[item.value] > 0" type="danger">减{{service_fee_amts.discounts[item.value]}}</van-tag>
              </div>
             </span>
          </div>
          <div class="period-row title2">{{payment_way_desc}}开始月份</div>
          <div>
            <van-datetime-picker
              :formatter="formatter"
              :visible-item-count="2"
              :show-toolbar="false"
              v-model="paymentDateStartValue"
              type="year-month"
              :min-date="paymentDateStart.minDate"
              :max-date="paymentDateStart.maxDate"
            />
          </div>
          <div class="period-row title2">{{payment_way_desc}}结束月份</div>
          <div>
            <van-datetime-picker
              :formatter="paymentDateEndFormat"
              :visible-item-count="isNormalPaymentWay() ? 1 : 2"
              :show-toolbar="false"
              v-model="paymentDateEndValue"
              :min-date="paymentDateEnd.minDate"
              :max-date="paymentDateEnd.maxDate"
              type="year-month"
              class="end-time"
            />
          </div>
          <div class="period-row center">
            <van-button type="next" @click="confirm(true)">确认选择</van-button>
          </div>
        </van-popup>
      </template>
      <template v-slot>
        <div v-if="allow_select_payment_term">{{paymentTermLabel}}</div>
        <div class="period-date">{{periodDateLabel}}</div>
      </template>
    </van-cell>
    <div class="clear"></div>
  </div>
</template>

<script>
import _ from "lodash";
import { Toast, version, Dialog, DatetimePicker } from "vant";
import moment from "moment";
import {
  PaymentUsageList,
  PaymentWayList,
  CensusTypeList,
  PaymentItemExList,
  PaymentPaybackItemExList,
  PaymentItemRefs
} from "@/pages/util/state_desc";

export default {
  components: {
    [DatetimePicker.name]: DatetimePicker
  },
  name: "sby-block-period",
  props: {
    allow_select_payment: {
      type: Boolean,
      default: true,
    },
    allow_select_payment_term: {
      type: Boolean,
      default: true,
    },
    payment_term: {
      type: String
    },
    payment_items: {
      type: Array
    },
    payment_way: {
      type: String,
      required: true
    },
    payment_way_desc: {
      type: String
    },
    date_start: {
      type: String
    },
    readonly: {
      type: Boolean,
      default: false
    },
    enable_discount: {
      type: Boolean,
      default: false
    },
    date_end: {
      type: String
    },
    list: {
      type: Array
    },
    service_fee_amts: {
      type: Object
    }
  },
  model: {
    event: "change"
  },
  data() {
    return {
      popupshow: false,
      paymentDateStartValue: null,
      periodDateLabel: "",
      paymentTermLabel: "",
      new_payment_items: [],
      paymentDateStart: {
        minDate: new Date(),
        maxDate: new Date()
      },
      paymentDateEnd: {
        minDate: new Date(),
        maxDate: new Date()
      },
      paymentDateEndValue: null,
      paymentTerm: "",
      isMounted: true,
      payment_item_refs: PaymentItemRefs
    };
  },
  mounted() {
    this.paymentDateStartValue = this.date_start;
    this.paymentDateEndValue = this.date_end;
    this.paymentTerm = this.payment_term;
    this.new_payment_items = this.payment_items;
    this.periodDateLabel = this.getPaymentPeriodLabel();
    this.paymentTermLabel = this.getPaymentTermLabel();
    if (!this.isNormalPaymentWay()) {
      // 初始化补缴纳周期
      this.initPaybackPeriod();
    }
    this.isMounted = false;
  },
  watch: {
    date_end(date_end) {
    //  this.paymentDateEndValue = date_end;
    },
    paymentTerm(paymentTerm) {
      if (!this.isNormalPaymentWay()) {
        return;
      }
      this.paymentDateStartValue = this.getNowMonthDate(this.date_start);
      this.paymentDateStart = {
        minDate: this.getNowMonthDate(this.date_start),
        maxDate: this.getFirstDayOfMonth()
          .add(2, "months")
          .toDate()
      };
    },
    paymentDateStartValue(dateStart) {
      const months = this.getDiffMonths();

      if (this.isNormalPaymentWay()) {
        this.paymentDateEndValue = moment(dateStart)
          .add(months, "months")
          .toDate();
        this.paymentDateEnd = {
          minDate: this.paymentDateEndValue,
          maxDate: this.paymentDateEndValue
        };
        return;
      }
      // 补缴
      if (this.payment_items.includes("shebao")) {
        this.paymentDateEnd = {
          minDate: this.getDateBySubtractMonth(1),
          maxDate: this.getDateBySubtractMonth(1)
        };
        this.paymentDateEndValue = this.paymentDateEnd.maxDate;
        return;
      }
      if (this.payment_items.includes("gongjijin")) {
        this.paymentDateEnd.minDate = this.getDateBySubtractMonth(months);
        this.paymentDateEnd.maxDate = this.getDateBySubtractMonth(1);
        this.paymentDateEndValue = this.paymentDateEnd.maxDate;
      }
    },
    paymentDateEndValue(dateEnd) {
      this.emitClick();
    },
  },

  methods: {
    isActivedItem(item) {
      return item === this.paymentTerm;
    },
    confirm(isClose) {
      if (this.allow_select_payment && this.isNormalPaymentWay() && !this.paymentTerm) {
        Toast("请选择缴纳周期");
        return;
      }

      if (
        moment(this.paymentDateStartValue).isAfter(
          moment(this.paymentDateEndValue)
        )
      ) {
        Toast("结束月份必须在开始月份之后");
        return;
      }
      this.emitClick();
      if (this.popupshow && isClose) {
        this.popupshow = false;
      }
    },
    emitClick() {
      if (this.new_payment_items.length === 0) {
        this.new_payment_items = ['shebao', 'gongjijin'];
       Toast("至少需要选择一个代缴项目"); 
        return;
      }
      this.$emit("confirm", {
        paymentTerm: this.paymentTerm,
        paymentDateStart: this.paymentDateStartValue ? moment(this.paymentDateStartValue).format(
          "YYYY-MM-DD"
        ) : '',
        paymentDateEnd: this.paymentDateEndValue ?  moment(this.paymentDateEndValue).format("YYYY-MM-DD") : '',
        paymentItems: this.new_payment_items
      });
      this.periodDateLabel = this.getPaymentPeriodLabel();
      this.paymentTermLabel = this.getPaymentTermLabel();
    },
    getPaymentItemList() {
      return this.payment_way === "payback"
        ? PaymentPaybackItemExList
        : PaymentItemExList;
    },
    getPaymentTermLabel() {
      if (this.paymentTerm && this.isNormalPaymentWay()) {
        return this.list.find(v => v.value === this.paymentTerm).name;
      }

      if (
        !this.isNormalPaymentWay() &&
        this.paymentDateStartValue &&
        this.paymentDateEndValue
      ) {
        const monthDifference =
          moment(this.paymentDateEndValue).diff(
            this.paymentDateStartValue,
            "months"
          ) + 1;
        return `共${monthDifference}个月`;
      }
    },
    getPaymentPeriodLabel() {
      if (!this.paymentDateStartValue) {
        return '';
      }
      if (!this.allow_select_payment && moment(this.paymentDateStartValue).format("YYYY-MM") === moment(this.paymentDateEndValue).format("YYYY-MM")) {
        return moment(this.paymentDateStartValue).format("YYYY-MM");
      }
      if (this.paymentDateStartValue && this.paymentDateEndValue) {
        return (
          moment(this.paymentDateStartValue).format("YYYY-MM 至") +
          moment(this.paymentDateEndValue).format(" YYYY-MM")
        );
      }
    },
    changePaymentTerm(pt) {
      this.paymentTerm = pt;
    },
    initPaybackPeriod() {
      // 如果当前是 补缴社保：开始选择最近三个月（如当前4月，只能选择1-3月作为开始时间，截止补缴时间不能是当前月）
      const months = this.getDiffMonths();
        this.paymentDateStartValue = this.getDateBySubtractMonth(
            parseInt(3)
          );

      if (this.payment_items.includes("shebao")) {
        this.paymentDateStart.minDate = this.getDateBySubtractMonth(months + 1);
        this.paymentDateStart.maxDate = this.getDateBySubtractMonth(1);
        return;
      }
      // 如果当前是 补缴公积金：开始时间选择最近6个月，并且结束时间为当前月（不可改)
      if (this.payment_items.includes("gongjijin")) {
        this.paymentDateStart.minDate = this.getDateBySubtractMonth(months);
        this.paymentDateStart.maxDate = this.getDateBySubtractMonth(1);
      }
    },
    paymentDateEndFormat(type, value) {
      if (this.isNormalPaymentWay() && !this.paymentTerm) {
        return "-";
      } else {
        return this.formatter(type, value);
      }
    },
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      }
      return value;
    },
    isNormalPaymentWay() {
      return this.payment_way === "normal";
    },
    getFirstDayOfMonth() {
      return moment()
        .date(1)
        .hour(0)
        .minute(0)
        .second(0)
        .millisecond(0);
    },
    getNowMonthDate(date_start) {
      if (date_start) {
        return moment(date_start).toDate();
      }
      return this.getFirstDayOfMonth().toDate();
    },
    getDateBySubtractMonth(months) {
      return this.getFirstDayOfMonth()
        .subtract(months, "months")
        .toDate();
    },
    getDiffMonths() {
      let months = 24;
      if (this.paymentTerm === "month") {
        months = 0;
      } else if (this.paymentTerm === "halfyear") {
        months = 5;
      } else if (this.paymentTerm === "year") {
        months = 5;
      }
      if (
        this.payment_way === "payback"
      ) {
        months = this.payment_items.includes("shebao") ? 2 : 6;
      }
      return months;
    }
  }
};
</script>

<style lang="less" scoped>
.sby-period-container {
  .center {
    text-align: center;
  }
  .van-picker-column__item--selected {
    color: #9e9e9e !important;
  }
  .period-row {
    margin: 10px 15px 10px 15px;
    .item {
      display: inline-block;
      padding: 5px 9px;
      margin: 0 20px 10px 0;
      // height: 38px;
      min-width: 80px;
      // line-height: 28px;
      font-size: 12px;
      text-align: center;
      color: #323233;
      border: 1px solid #b1bec1;
      border-radius: 3px;
      box-sizing: border-box;
      .fees {
        display: block;
        text-align: center;
        font-size: 11px;
        position: relative;
        font-size: 11px;
        .origin-fee {
          text-decoration: line-through;font-size:10px;
        }
      }

      .van-tag {
    position: absolute;
    top: -29px;
    left: 48px;
    font-size: 11px;
    padding: 0;
    width: 35px;
      }
    }
    .desc {
      display: block;
      font-size: 12px;
      color: gray;
    }

    .van-button--next {
      min-width: 150px;
    }
  }
  .title {
    font-size: 18px;
    font-weight: 600;
  }

  .title2 {
    font-size: 14px;
  }
}

.sby-period.van-cell {
  //height: 68px;
  .period-date {
    //color: #676768;
    font-size: 16px;
   // line-height: 16px;
  }
  .van-cell__title {
    //margin-top: 10px;
    color: #5d5c5c !important;
  }
  .van-icon-arrow {
    //margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sby-period-cell.vue